<template>
  <UiInputDatePickerVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'

export default {
  name: 'UiInputDatePickerVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    // type: null skips Vue's runtime type check — Object would fail it for a null
    // value (null is not typeof 'object' per Vue's isObject check), which is the
    // normal state before a date is picked. The PropType cast keeps this typed as
    // Date | null for TypeScript regardless.
    modelValue: { type: null as unknown as PropType<Date | null>, required: true as const },
    locale: { type: String as PropType<'da' | 'en'>, default: undefined },
    dateFormat: { type: [String, Function] as PropType<string | ((date: Date) => string)>, default: undefined },
    minDate: { type: Object as PropType<Date>, default: undefined },
    maxDate: { type: Object as PropType<Date>, default: undefined },
    placeholder: { type: String, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
    timepicker: { type: Boolean, default: undefined },
    autoClose: { type: Boolean, default: undefined },
  },
}
</script>

